import { Switch as AntSwitch } from 'antd';
import styled from 'styled-components';

const Switch = styled(AntSwitch)`
  &.ant-switch {
    background: var(--greyscale-concrete);

    &:hover {
      background: var(--greyscale-concrete);
    }

    &-checked {
      background-color: var(--primary-oqio-blue);

      &:hover {
        background: var(--primary-oqio-blue) !important;
      }
    }

    .ant-switch-handle {
      &::before {
        background-color: var(--greyscale-white);
        border: 1px solid var(--greyscale-dark-white);
        box-shadow: 0 0 4px 1px rgb(17 17 17 / 10%);
      }
    }

    &:not(.ant-switch-disabled):active {
      .ant-switch-handle::before {
        inset-inline: 0;
      }

      .ant-switch-inner {
        .ant-switch-inner-checked,
        .ant-switch-inner-unchecked {
          margin-inline: 0;
        }
      }
    }

    .ant-wave {
      display: none;
    }
  }
`;

export default Switch;
